import React, { useState } from "react";
import { works } from "../lib/allProject";
import WorkCard from "./smallComponentes/WorkCard";
import FilterComponent from "./smallComponentes/Filter";
import ProjectModals from "./smallComponentes/Modal";

const AllWorks = (props) => {
  const { actions, closeProjects } = props;
  const [workdata, setWorkData] = useState("");
  const [filteredWorks, setFilteredWorks] = useState(works);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = (link) => {
    setWorkData(link);
    setModalIsOpen(true);
  };

  return (
    <>
      <div className="flex flex-col pt-[70px] h-screen bg-[#0f172a] px-[50px] items-center ">
        <FilterComponent
          actions={actions}
          setFilteredWorks={setFilteredWorks}
          works={works}
          closeProjects={closeProjects}
        />
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3  w-[90vw]  max-w-6xl pb-[100px]">
          {/* Grid Item */}

          {filteredWorks.map((work, key) => {
            return <WorkCard work={work} key={key} openModal={openModal} />;
          })}
        </div>

        <ProjectModals
          setModalIsOpen={setModalIsOpen}
          modalIsOpen={modalIsOpen}
          workdata={workdata}
        />
      </div>
    </>
  );
};

export default AllWorks;
